import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import UserDetails from "./UserDetails";

const VerifyPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [verified, setVerified] = useState(false);
  const [message, setMessage] = useState("");
  const [token, setToken] = useState("");

  useEffect(() => {
    const verifyToken = async () => {
      const searchParams = new URLSearchParams(location.search);
      const token = searchParams.get("token");
      console.log("token in ver", token);

      if (!token) {
        setMessage("Invalid verification link.");
        return;
      }

      setToken(token);

      try {
        const response = await fetch(
          `https://api.consent.behooked.co/verify-token?token=${token}`
        );
        const data = await response.json();

        if (response.ok) {
          setVerified(true);
          // navigate("/consent-form", { state: { token } });
        } else {
          setMessage(data.error || "Verification failed.");
        }
      } catch (error) {
        setMessage("An error occurred during verification.");
      }
    };

    verifyToken();
  }, [location]);

  const handleUserDetailsSubmit = (formData) => {
    // Navigate to the recording page with the token and username
    navigate("/record", { state: { ...formData, token } });
  };
  console.log("token after usm", token);

  return (
    <div className="min-h-screen bg-white">
      {!verified ? (
        <div className="flex items-center justify-center h-screen">
          <h1 className="text-3xl font-medium">{message}</h1>
        </div>
      ) : (
        <UserDetails onSubmit={handleUserDetailsSubmit} token={token} />
      )}
    </div>
  );
};

export default VerifyPage;
